import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { getData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';

import { SAL1020_R01DetailDto, SAL1020_R01HeaderDto } from './Dto_SAL1020_R01';
import { SAL1020_R01Filter } from "./Store_SAL1020_R01";

const baseUrl = `${config.apiUrl}/SAL1020_R01`;

const getParams = (filter: Partial<SAL1020_R01Filter>, listLength?: number) => {	
	return {
		compCd: filter.compCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,
		empNo: filter.empNo || undefined,
		listLength: listLength || 0,
		refetchListLength: filter.refetchListLength || undefined
	}
}

/**
 * 수주 헤더 목록 조회
 * @param option 조회 옵션 ('search' 또는 'refetch')
 * @param params 검색 조건
 * @param listLength 기존 목록 길이
 */
export const getSAL1020_R01List = async (option: string, params: Partial<SAL1020_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<SAL1020_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

/**
 * 수주 헤더 전체 개수 조회
 * @param params 검색 조건
 */
export const getSAL1020_R01AllCount = async (params: Partial<SAL1020_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params, 0)
	});
}

/**
 * 수주 헤더 단건 조회
 * @param salesOrderNo 수주번호
 */
export const getSAL1020_R01One = async (salesOrderNo: string) => {
	const url = `${baseUrl}/one/${salesOrderNo}`;
	return await getData<ResponseDto<SAL1020_R01HeaderDto>>(url);
}

/**
 * 수주 상세 목록 조회
 * @param salesOrderNo 수주번호
 */
export const getSAL1020_R01DetailList = async (salesOrderNo: string) => {
	const url = `${baseUrl}/detail/${salesOrderNo}`;
	return await getData<ResponseDto<SAL1020_R01DetailDto[]>>(url);
}

/**
 * 수주 상세 엑셀 다운로드
 * @param salesOrderNo 수주번호
 */
export const downloadExcel_SAL1020_R01 = async (salesOrderNo: string) => {
	const url = `${baseUrl}/detail/excel/${salesOrderNo}`;
	return await getData<ResponseDto<string>>(url);
}

